import React from 'react'
import ReactDOM from 'react-dom'
import './GenomeProject.css';
import PropTypes from 'prop-types'
import GenomeProject from './GenomeProject';
import FileInput from "../../proksee-viewer/presenters/FileInput";
import Button from "../../proksee-viewer/presenters/Button";
import {Select, Option} from "../../proksee-viewer/presenters/Select";
import ImageButton from "../../proksee-viewer/presenters/ImageButton";
import ExternalLink from "../../proksee-viewer/presenters/ExternalLink";
import HelpElement from "../../proksee-viewer/presenters/HelpElement";
// import * as helpers from "../proksee-viewer/support/Helpers";

class ReadsProject extends React.Component {



  static propTypes = {
    active: PropTypes.bool,
    role: PropTypes.oneOf(['admin', 'tester', '']),
  }

  static defaultProps = {
    active: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      valid: false,
      species: 'Detect',
      forwardReadsValid: false,
      reverseReadsValid: undefined, // Undefined will still be valid since this is optional
    };
    this.onValidate = this.onValidate.bind(this);
    // Species Names extracted from first column of the file:
    // proksee-cmd/proksee/database/refseq_short.csv
    // 2022-09-14
    // Database Date: ??
    this.speciesNames = ['Acinetobacter baumannii', 'Acinetobacter pittii', 'Bacilli bacterium', 'Bacillus anthracis', 'Bacillus cereus', 'Bacillus subtilis', 'Bacillus thuringiensis', 'Bacillus velezensis', 'Bacteroidales bacterium', 'Bacteroides fragilis', 'Bacteroides thetaiotaomicron', 'Bifidobacterium adolescentis', 'Bifidobacterium longum', 'Bifidobacterium pseudocatenulatum', 'Borreliella burgdorferi', 'Brucella abortus', 'Brucella melitensis', 'Burkholderia cenocepacia', 'Burkholderia cepacia', 'Burkholderia gladioli', 'Burkholderia pseudomallei', 'Burkholderia stagnalis', 'Burkholderia ubonensis', 'Campylobacter coli', 'Campylobacter concisus', 'Campylobacter fetus', 'Campylobacter jejuni', 'Campylobacter lari', 'Candidatus Bathyarchaeota archaeon', 'Candidatus Marinimicrobia bacterium', 'Citrobacter freundii', 'Clostridiaceae bacterium', 'Clostridiales bacterium', 'Clostridioides difficile', 'Clostridium beijerinckii', 'Clostridium botulinum', 'Clostridium perfringens', 'Clostridium sporogenes', 'Corynebacterium diphtheriae', 'Cronobacter sakazakii', 'Cutibacterium acnes', 'Enterobacter asburiae', 'Enterobacter cloacae', 'Enterobacter hormaechei', 'Enterococcus faecalis', 'Enterococcus faecium', 'Enterococcus hirae', 'Escherichia albertii', 'Escherichia coli', 'Flavobacteriaceae bacterium', 'Flavobacterium psychrophilum', 'Francisella tularensis', 'Haemophilus influenzae', 'Helicobacter pylori', 'Klebsiella aerogenes', 'Klebsiella pneumoniae', 'Klebsiella quasipneumoniae', 'Klebsiella variicola', 'Lachnospiraceae bacterium', 'Lacticaseibacillus paracasei', 'Lactiplantibacillus plantarum', 'Lactobacillus rhamnosus', 'Lactococcus lactis', 'Legionella pneumophila', 'Leptospira interrogans', 'Listeria innocua', 'Listeria monocytogenes', 'Listeria seeligeri', 'Listeria welshimeri', 'Moraxella catarrhalis', 'Mycobacterium avium', 'Mycobacterium tuberculosis', 'Mycobacteroides abscessus', 'Mycoplasma bovis', 'Neisseria gonorrhoeae', 'Neisseria meningitidis', 'Oenococcus oeni', 'Pasteurella multocida', 'Pediococcus acidilactici', 'Proteus mirabilis', 'Pseudomonas aeruginosa', 'Pseudomonas syringae', 'Pseudomonas viridiflava', 'Rhizobium leguminosarum', 'Rhodobacteraceae bacterium', 'Rhodococcus hoagii', 'Ruegeria conchae', 'Salmonella enterica', 'Serratia marcescens', 'Shigella boydii', 'Shigella dysenteriae', 'Shigella flexneri', 'Shigella sonnei', 'Sinorhizobium meliloti', 'Staphylococcus aureus', 'Staphylococcus epidermidis', 'Staphylococcus haemolyticus', 'Staphylococcus pseudintermedius', 'Stenotrophomonas maltophilia', 'Streptococcus agalactiae', 'Streptococcus equi', 'Streptococcus mitis', 'Streptococcus mutans', 'Streptococcus pneumoniae', 'Streptococcus pyogenes', 'Streptococcus suis', 'Turicibacter sanguinis', 'Vibrio cholerae', 'Vibrio parahaemolyticus', 'Vibrio vulnificus', 'Xanthomonas campestris', 'Xanthomonas citri', 'Xanthomonas oryzae', 'Xanthomonas phaseoli', 'Yersinia enterocolitica', 'Yersinia pestis', 'Yersinia pseudotuberculosis'];
  }

  isValid() {
    const { forwardReadsValid, reverseReadsValid } = this.state;
    return ( forwardReadsValid && (reverseReadsValid || reverseReadsValid === undefined) )
  }

  onValidate(attribute, valid) {
    this.setState({[attribute]: valid}, () => this.setState({valid: this.isValid()}))
  }

  // Right now we only have one example
  // - paired doesn't do anything yet but could be used if we have paired vs single reads 
  renderExample(id, name, description, platform, paired=false) {
    // Remove '.ds' from downsampled examples (Note we currently do not have downsampled examples)
    const accession = id.replace(".ds", '');
    const downsampled = (id !== accession) ? <strong>*</strong> : '';

    return (
      <div className='example-block'>
        <a className='example-btn-start' href={`/projects/example?source=reads&id=${id}`}>View</a>
        <div className='example-details'>
          <div className='example-name' title={name}>{name}</div>
          <div className='example-description'>{description} ({platform}) {downsampled}</div>
          <div className='example-genbank'>
            <ImageButton className='example-genbank-download' text='Reads 1' size='small' imageName='downloadSmall' title='Download FASTQ File' width={72}
              onClick={() => { GenomeProject.downloadURI(`/data/reads/${id}.R1.fastq.zip`, `${id}.R1.fastq.zip`) }}
            />
            <ImageButton className='example-genbank-download' text='Reads 2' size='small' imageName='downloadSmall' title='Download FASTQ File' width={72}
              onClick={() => { GenomeProject.downloadURI(`/data/reads/${id}.R2.fastq.zip`, `${id}.R2.fastq.zip`) }}
            />
            <ExternalLink name={accession} link={`https://www.ncbi.nlm.nih.gov/sra/${accession}`} className='example-genbank-id' size={10} />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { valid, species } = this.state;
    const { active, role } = this.props;

    // Only retrun field name if active.
    // This prevent sending the file when inactive.
    const forwardFieldName = active ? "project[jobs_attributes][0][files_attributes][0]" : '';
    const reverseFieldName = active ? "project[jobs_attributes][0][files_attributes][1]" : '';
    const speciesFieldName = active ? "project[jobs_attributes][0][inputs][species]" : '';
    const source = active ? "project[source]" : '';


    //<div className='ps-alert'>
    //  Proksee Assemble is undergoing beta testing. If you have any problems with your assembly please email us and include your project ID: 
    //  &nbsp;<a href="mailto:info@proksee.ca?subject=Assembly%20Feedback">Assembly Feedback</a>
    //</div>

    //// if (['tester', 'admin'].includes(role)) {
      return (
        <div className='new-project-page'>
          <input id="source" name={source} type="hidden" value="reads" />
          <div>Forward Reads</div>
          <FileInput
            sourcesAllowed={['upload']}
            fieldName={forwardFieldName}
            help=""
            fileType='fastq'
            useUppy
            onValidate={ (value) => this.onValidate('forwardReadsValid', value) }
            validationRules={{
              validMaxSize: 1024*1024*1024,
              validExtensions: ['fastq', 'gz', 'zip']
            }}
          />
          <div>Reverse Reads (Optional)</div>
          <FileInput
            sourcesAllowed={['upload']}
            fieldName={reverseFieldName}
            help="Reads must be in fastq format and can be optionally compressed (allowed extensions: fastq, gz, zip). Maximum file size is 1 GB. Files are deleted after assembly to save space."
            fileType='fastq'
            useUppy
            onValidate={ (value) => this.onValidate('reverseReadsValid', value) }
            validationRules={{
              validMaxSize: 1024*1024*1024,
              validExtensions: ['fastq', 'gz', 'zip']
            }}
          />

          <div>Species</div>
          <Select
            showSearch
            name={speciesFieldName}
            defaultValue='Detect'
            onChange={ (value) => this.setState({species: value}) }
            optionFilterProp="children"
            placeholder="Select a Species"
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
          >
            <Option value="Detect">Auto Detect</Option>
            {this.speciesNames.map( s => <Option key={s} value={s}>{s}</Option>)}
          </Select>
          <HelpElement text='The species is used for checking the assembly quality.' />
          <input type='hidden' name={speciesFieldName} value={species} />
          <input className='hidden-submit' type='submit' onClick={(e)=> {
            if (!valid) {e.preventDefault();}
          }}/>

          <div className='btn-submit-or-examples'>
            <Button
              type='primary'
              className='btn-submit-project'
              onClick={() => document.forms['new_project'].submit()}
              width={150}
              height={38}
              disabled={!valid}>
              Create Map
            </Button>

            <fieldset className='or-examples'><legend>OR</legend></fieldset>

            <div className='example-section'>
              <div className='run-example'>View Example Results</div>
              { this.renderExample('ERR495003', 'Mycobacterium tuberculosis', '770,994 Paired Reads', 'Illumina HiSeq 2000') }
              { this.renderExample('SRR13968505', 'Staphylococcus aureus', '1,040,445 Paired Reads', 'Illumina HiSeq 2500') }
              { this.renderExample('SRR22340759', 'Listeria monocytogenes', '857,666 Paired Reads', 'Illumina NextSeq 500') }
              <div className='example-help'>Click <strong>View</strong> to create a new example reads project using pregenerated results from the provided FASTQ files. For each example, there are buttons to download the reads as well as a link to view their source at the <ExternalLink link='https://www.ncbi.nlm.nih.gov/sra' name='Short Read Archive (SRA)' size={10} className='json-link' />.</div>
            </div>
          </div>

        </div>
      );
      //{ this.renderExample('SRR13968505.ds', 'Staphylococcus aureus', '564,020 Paired Reads', 'Illumina HiSeq 2500') }
      //<div className='example-help'><strong>*</strong> Reads have been downsampled.</div>
  }

}
export default ReadsProject;

